module.exports = __webpack_public_path__ + "img/avatar.1b836d74.png";